import { render, staticRenderFns } from "./MvRow.vue?vue&type=template&id=c5f57114&scoped=true"
import script from "./MvRow.vue?vue&type=script&lang=js"
export * from "./MvRow.vue?vue&type=script&lang=js"
import style0 from "./MvRow.vue?vue&type=style&index=0&id=c5f57114&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f57114",
  null
  
)

export default component.exports